

loadjs([
  "https://js.api.here.com/v3/3.1/mapsjs-ui.css",
  "https://js.api.here.com/v3/3.1/mapsjs-core.js",
  "https://js.api.here.com/v3/3.1/mapsjs-service.js",
  "https://js.api.here.com/v3/3.1/mapsjs-ui.js",
  "https://js.api.here.com/v3/3.1/mapsjs-mapevents.js",
], "mapReady", {
  async: false
});

loadjs.ready("mapReady", {
  success: function() {
    var platform = new H.service.Platform({
      "apikey": "_KW7JJPELxsR7Gq95E--BG1E0_iWkPIGhImTYwADXcg"
    });

    jQuery_custom('[data-component="venue-map"]').each(function () {
      var venuePosition = {
        lat: this.getAttribute("data-latitude"),
        lng: this.getAttribute("data-longitude")
      }
      if(this.getAttribute("data-locale") && ["de","fr","it","en"].includes(this.getAttribute("data-locale"))) {
        var language = this.getAttribute("data-locale") + "-" + this.getAttribute("data-locale").toUpperCase()
      }
      else {
        var language = "de-DE"
      }
      var defaultLayers = platform.createDefaultLayers()

      var map = new H.Map(
        this,
        defaultLayers.vector.normal.map,{
        center: venuePosition,
        zoom: 16
      });

      var behavior = new H.mapevents.Behavior(
        new H.mapevents.MapEvents(map)
      )
      var ui = H.ui.UI.createDefault(
        map,
        defaultLayers, language
      )

      var venueMarker = new H.map.Marker(
        venuePosition,
        {
          icon: new H.map.Icon(
            "https://assets-tort.blutspende.ch/assets/blutspendech/terminpointer-3839f62bcd7417be166bc12c917bfb126e06295ac5affe2592acd4bd941a1e51.png",
            {
              anchor: { x: 32, y: 32 }
            }
          )
        }
      )
      map.addObject(venueMarker)
    })
  },
  error: function(depsNotFound) {
    jQuery_custom('[data-component="venue-map"]').html("<b>Die Karte konnte leider nicht geladen werden.<b>")
  },
});
